<template>
  <div
    :class="[$style.box]"
    :style="{background: params.background}"
  >
    <div
      :class="$style.icon"
    >
      <svg-sprite
        :name="params.iconName"
        :size="params.iconSize"
        :type="params.iconType"
        :color="params.iconColor"
      />
    </div>
    <div :class="$style.message">
      <div :style="styles.message" v-html="text" />
    </div>
  </div>
</template>

<script>
import svgSprite from '$$vueCmp/VueIcon/svgSprite.vue';

const defaultStyles = {
  message: { 'font-size': '14px', 'white-space': 'nowrap' },
};

export default {
  name: 'InlineNotification',
  components: {
    svgSprite,
  },
  props: {
    type: { type: String },
    text: { type: String, default: '' },
    messageStyles: { type: Number, required: false, default: () => {} },
  },

  data() {
    return {
      defaultParams: {
        background: '#FFEBCC',
        iconName: 'warning-1',
        iconSize: '20',
        iconType: 'bold',
        iconColor: '#FF9A00',
      },
    };
  },
  computed: {
    params() {
      if (this.type === 'warning') {
        return {
          background: '#FFEBCC',
          iconName: 'warning-1',
          iconSize: '20',
          iconType: 'bold',
          iconColor: '#FF9A00',
        };
      }

      if (this.type === 'info') {
        return {
          background: '#FFEBCC',
          iconName: 'info',
          iconSize: '20',
          iconType: 'bold',
          iconColor: '#1565C0',
        };
      }

      return this.defaultParams;
    },
    styles() {
      return {
        message: {
          ...defaultStyles.message,
          ...this.messageStyles,
        },
      };
    },
  },

};
</script>

<style module src='./less/nofitication.less'></style>
